
import api from './api';

class Rating {

	constructor (Api) {
		this.Api = Api;
	}

	getStats (query) {
		return this.Api.get({
			url:  'v1.1/m/rating/stats/',
			query
		}).then(response => response.stats);
	}

}

Rating.$inject = ['Api'];

export default angular.module('service.rating', [api])
	.service('Rating', Rating)
	.name;



// WEBPACK FOOTER //
// ./src/service/rating.js